/**
 * Single source of truth for subscription plan prices (USD).
 * Used for display (e.g. BillingPage) and conversion tracking value (Meta/Reddit).
 * Keep these in sync with the Stripe price configuration.
 */
export const PLAN_PRICES: Record<'monthly' | 'annual', number> = {
  monthly: 9.99,
  annual: 99.99,
};
